<template>
    <section class="text-left px-8 py-6 text-gray-200">
      <div class="text-center"><span class="text-[#ed6e4e] text-[28px] font-semibold font-['Outfit'] leading-[34px]">Effortless</span><span class="text-[#403b38] text-[28px] font-semibold font-['Outfit'] leading-[34px]"> Data Streaming with Free Kafka Access</span></div><br>
      <div class="text-[#403b38] text-base font-normal font-['Outfit'] leading-snug">The best way to stream data effortlessly. With Event Mock’s free, publicly accessible Kafka service, start consuming built-in topics instantly or create custom, secure topics tailored just for you—all with just a few clicks.</div>
    </section>
  </template>
  
  <script>
  export default {
    name: "HeroSection",
  };
  </script>
  